export default __webpack_public_path__ + "static/logo-9d2a186a19a722aff712405b1e141a6c.jpg";